module.exports = __webpack_public_path__ + "img/icon_map_6_off_110.7e396567.png";